import { render, staticRenderFns } from "./WorkDaysCalendar.vue?vue&type=template&id=32a55e18&scoped=true"
import script from "./WorkDaysCalendar.vue?vue&type=script&lang=js"
export * from "./WorkDaysCalendar.vue?vue&type=script&lang=js"
import style0 from "./WorkDaysCalendar.vue?vue&type=style&index=0&id=32a55e18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a55e18",
  null
  
)

export default component.exports